import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import Sidebar from "../Components/Sidebar/Sidebar";
import Topbar from "../Components/Topbar/Topbar";
import { connect } from "react-redux";
import './style.css'
import ReadyGroup from "./ReadyGroup";
import PendingGroup from "./PendingGroup";
import WaitGroup from "./WaitGroup";
import LoadingSpinner from "../Components/LoadingSpinner";
import { getGroupedList } from "../Utils/utils";

const Grouped = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState('ready')
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSubmitWait, setIsSubmitWait] = useState(false);
  const [isSubmitPending, setIsSubmitPending] = useState(false);
  const [listArr, setListArr] = useState([]);
  const [noteNew, setNoteNew] = useState('');
  const [recallApi, setRecallApi] = useState(false);

 

  const getGrouped = async (status) => {
    setIsLoading(true);
    var res = await getGroupedList(status)
    if (res.status == 200) {
      setListArr(res.data)
      setRecallApi(false)
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getGrouped(2)
  }, [])

  useEffect(() => {
    if (recallApi == true && isSubmitPending == true) {
      getGrouped(3)
    } else if (recallApi == true && isSubmitWait == true) {
      getGrouped(4)
    } else if (recallApi == true) {
      getGrouped(2)
    }
  }, [recallApi])

  useEffect(() => {
    if (isSubmitPending == true) {
      getGrouped(3)
    } else if (isSubmitWait == true) {
      getGrouped(4)
    } else {
      getGrouped(2)
    }
  }, [noteNew])

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar/>
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <Tabs
                    onSelect={(e) => {
                      setKey(e)
                      if (e == "ready") {
                        setIsSubmitPending(false)
                        setIsSubmitWait(false)
                        getGrouped(2)
                      } else if (e == "pending") {
                        setIsSubmitPending(true)
                        setIsSubmitWait(false)
                        getGrouped(3)
                      }
                      else {
                        setIsSubmitPending(false)
                        setIsSubmitWait(true)
                        getGrouped(4)
                      }
                    }}
                    activeKey={key}
                    id="uncontrolled-tab-example"
                    className="setting-group"
                    justify
                  >
                    <Tab eventKey="ready" title="Ready for SOU"  >
                      {key == 'ready' &&
                        <ReadyGroup
                          isSubmit={isSubmit}
                          data={listArr}
                          setNoteNew={setNoteNew}
                          setRecallApi={setRecallApi}
                        // setIsSubmit={setIsSubmit}
                        // setSelectArray={setSelectArray}
                        // setIsRegular={setIsRegular}
                        />
                      }
                    </Tab>
                    <Tab eventKey="pending" title="Pending Instructor Acceptance" >
                      {/* {key == 'flex' &&  */}
                      {isSubmitPending == true ?
                        <PendingGroup
                          // isSubmitFlex={isSubmitPending}
                          // setIsSubmitFlex={setIsSubmitFlex}
                          // setSelectArray={setSelectArray}
                          // setIsFlex={setIsFlex}
                          data={listArr}
                          setNoteNew={setNoteNew}
                          setRecallApi={setRecallApi}
                        />
                        : null
                        // (isSubmitFlex == true && isFlex == true) && <FlexGroupedClasses
                        //   selectArray={selectArray}
                        // />
                      }
                    </Tab>
                    <Tab eventKey="waiting" title="Waiting Instructor"  >
                      {/* {key == 'regular' &&  */}
                      {isSubmitWait == true ?
                        <WaitGroup
                          // isSubmit={isSubmitWait}
                          data={listArr}
                          setNoteNew={setNoteNew}
                          setRecallApi={setRecallApi}
                        // setIsSubmit={setIsSubmit}
                        // setSelectArray={setSelectArray}
                        // setIsRegular={setIsRegular}
                        />
                        : null
                        // (isSubmit == true && isRegular == true) && <GroupedClasses
                        //   selectArray={selectArray}
                        // />
                      }
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </Col>
        </Row>

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  // ...state
});
const mapDispatchToProps = dispatch => ({
  // rotateAction: (payload) => dispatch(userAction(payload))
});
export default connect(mapStateToProps, mapDispatchToProps)(Grouped);